const formatUrl = (url = '') => {
  if (!url) return ''

  if (/^https?:\/\//.test(url)) return url

  return `//${url.replace(/^\/\//, '')}`
}

export default formatUrl
